<template>
  <div id="restore" :class="popupClasses">
    <div class="close__wrapper close__wrapper-center">
      <div class="popup__close" @click.prevent="closeModal(modal.name)">
        <img alt="image" src="@/assets/img/new/close.svg" />
      </div>
      <div class="header__popup column">
        <span class="header__popup-title">Восстановить пароль</span>
        <span class="header__popup-text"
          >Введите свой E-mail и мы отправим вам сообщение с новым паролем на
          почту</span
        >
      </div>
      <ValidationObserver v-slot="{ passes }">
        <form class="footer__popup" @submit.prevent="passes(Restore)">
          <div class="inputblock__full">
            <span class="subtitle">Электронная почта</span>
            <AppInput
              class=""
              rules="required|email"
              v-bind="{ bg, label: 'Email', type: 'text' }"
              v-model="email"
            />
          </div>

          <button type="submit" class="redbtn">
            Восстановить
          </button>
        </form>
      </ValidationObserver>
    </div>
    <!-- <div class="header__popup">
      Восстановить пароль
      <div
        class="popup-close"
        :style="{ 'background-image': `url(${Close})` }"
        @click.prevent="closeModal(modal.name)"
      ></div>
    </div>
    <form @submit.prevent="Restore()">
      <div class="popup__body">
        <span class="input__title input__requier">
          Email или логин<span>*</span>:
        </span>
        <input class="input" type="text" v-model="email" />

        <div style="overflow: hidden; height: 100px;padding: 10px">
          <vue-recaptcha
            sitekey="6LcG8W4UAAAAAKfUwS1VM07rakvrZT4cgxMGOQXS"
            style="position: absolute;left: 13px"
            @verify="verified = true"
          ></vue-recaptcha>
        </div>

        <button class="btn btn__blue popup__register-btn">Восстановить</button>
      </div>
    </form> -->
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
//
//
import { mapActions } from "vuex";
import AppInput from "@/components/ui/AppInput.vue";
//
export default {
  name: "RestoreModal",
  props: ["modal", "bg"],
  //
  data() {
    return {
      verified: false,
      email: ""
    };
  },
  computed: {
    popupClasses() {
      if (window.screen.width < 680) {
        return ["mobpopup"];
      } else {
        return ["popup"];
      }
    }
  },
  //
  methods: {
    ...mapActions("modals", ["closeModal"]),
    ...mapActions("modals", ["openModal"]),

    Restore() {
      //   if (this.verified === false) {
      //     alert("Подтвердите что вы не робот!");
      //     return;
      //   }

      this.verified = false;

      return this.modal.success(this.email).then(response => {
        if (response) {
          if (response.data.result.ok == 1 && response.data.result.n == 1) {
            this.openModal({
              name: "info",
              title: "Новый пароль уже на почте!",

              success: this.userRestore
            });
            this.closeModal(this.modal.name);
          } else {
            this.closeModal(this.modal.name);
            this.$toast.error("Что-то пошло не так!", {
              position: "top-center"
            });
          }
        }
        //
        return response;
      });
    }
  },

  components: { VueRecaptcha, AppInput }
};
</script>
<style>
.inputblock__full {
  padding: 15px 0 0px 20px;
  border-radius: 20px;
  flex: 1 0 0;
  border: 2px solid var(--main-black);
  border-bottom: 4px solid var(--main-black);
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Modals/Restore.vue